import { Fragment, useEffect, useRef, useState } from 'react'
import { BANCOS } from '../Constantes'
import HttpService from '../services/HttpService'
import { Button, Card, EmptyState, Field, KebabMenu, Modal, Page, inputClass } from './ui'

export default function Cuentas(props) {
    const [open, setOpen] = useState(false)
    const [id, setId] = useState('')
    const [nombreCuenta, setNombreCuenta] = useState('')
    const [clabe, setClabe] = useState('')
    const [cuentas, setCuentas] = useState([])
    const [modalTitle, setModalTitle] = useState()
    const [banco, setBanco] = useState()
    const [claveBanco, setClaveBanco] = useState()
    const [validateCuentaError, setValidateCuentaError] = useState()
    const [validateNombreCuentaError, setValidateNombreCuentaError] = useState()
    const validForm = useRef(true)
    const creating = useRef(true)

    useEffect(() => {
        props.handleTitulo('Cuentas CLABE')
        getCuentas()
    }, [])

    const getCuentas = () => {
        HttpService.getAxiosClient().get('/cuentas').then((res) => setCuentas(res.data))
    }

    const handleClabe = (clabe) => {
        setClabe(clabe)
        preValidateClabe(clabe)
    }

    const handleNombreCuenta = (nombreCuenta) => {
        setNombreCuenta(nombreCuenta)
        setValidateNombreCuentaError(null)
    }

    const guardarClabe = () => {
        validateForm()
        if (validForm.current) {
            if (creating.current) {
                HttpService.getAxiosClient()
                    .post('/cuentas', { nombreCuenta, clabe, claveBanco, banco })
                    .then(() => {
                        getCuentas()
                        setOpen(false)
                    })
            } else {
                HttpService.getAxiosClient()
                    .post(`/cuentas/${id}`, { nombreCuenta, clabe, claveBanco, banco })
                    .then(() => {
                        getCuentas()
                        setOpen(false)
                    })
            }
        }
    }

    const validateForm = () => {
        validForm.current = true
        preValidateClabe(clabe)
        if (!/^[0-9]+$/.test(clabe) || clabe.length !== 18) {
            setValidateCuentaError('Debe estar formada de 18 números e iniciar con una clave de banco válida')
            validForm.current = false
        }
        if (!nombreCuenta.trim()) {
            setValidateNombreCuentaError('Debe especificar un nombre para la cuenta')
            validForm.current = false
        }
    }

    const preValidateClabe = (clabe) => {
        var b = BANCOS[clabe.substring(0, 3)]
        if (b) {
            setBanco(BANCOS[clabe.substring(0, 3)].nombreCorto)
            setClaveBanco(BANCOS[clabe.substring(0, 3)].clave_institucion)
        } else {
            setBanco(null)
            setClaveBanco(null)
        }
        if ((!/^[0-9]+$/.test(clabe) && clabe.length > 0) || (clabe.length >= 3 && b === undefined) || clabe.length > 18) {
            setValidateCuentaError('Debe estar formada de 18 números e iniciar con una clave de banco válida')
            validForm.current = false
        } else {
            setValidateCuentaError(null)
        }
    }

    const editar = (cuenta) => {
        setOpen(true)
        creating.current = false
        setModalTitle('Editar cuenta CLABE')
        setNombreCuenta(cuenta.nombreCuenta)
        setClabe(cuenta.cuenta)
        setBanco(cuenta.nombreBanco)
        setId(cuenta.id)
    }

    return (
        <Page
            description="Cuentas para recibir fondos de tus operaciones CoDi. Valídalas en el portal de Banco de México antes de operar."
            actions={
                <Button
                    onClick={() => {
                        creating.current = true
                        setOpen(true)
                        setModalTitle('Agregar cuenta CLABE')
                        setBanco(null)
                        setClabe('')
                        setNombreCuenta('')
                    }}
                >
                    Nueva cuenta
                </Button>
            }
        >
            {cuentas.length === 0 ? (
                <EmptyState title="Sin cuentas configuradas" description="Agrega una CLABE para recibir pagos." />
            ) : (
                <ul className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {cuentas.map((cuenta) => (
                        <li key={cuenta.id}>
                            <Card>
                                <div className="flex items-start justify-between border-b border-slate-100 px-5 py-4">
                                    <p className="text-sm font-semibold uppercase text-slate-900">{cuenta.nombreCuenta}</p>
                                    <KebabMenu
                                        items={[
                                            { label: 'Editar', onClick: () => editar(cuenta) },
                                            { label: 'Eliminar', onClick: () => {}, danger: true },
                                        ]}
                                    />
                                </div>
                                <div className="space-y-2 px-5 py-4 text-sm">
                                    <p><span className="text-slate-500">ID</span> <span className="ml-2 font-mono text-xs text-slate-700">{cuenta.id}</span></p>
                                    <p><span className="text-slate-500">Banco</span> <span className="ml-2 text-slate-900">{cuenta.nombreBanco}</span></p>
                                    <p><span className="text-slate-500">CLABE</span> <span className="ml-2 font-mono text-xs text-slate-700">{cuenta.cuenta}</span></p>
                                </div>
                            </Card>
                        </li>
                    ))}
                </ul>
            )}

            <Modal
                open={open}
                onClose={setOpen}
                title={modalTitle}
                footer={
                    <Fragment>
                        <Button variant="secondary" onClick={() => setOpen(false)}>Cancelar</Button>
                        <Button onClick={guardarClabe}>Guardar</Button>
                    </Fragment>
                }
            >
                <Field label="Nombre de la cuenta" error={validateNombreCuentaError}>
                    <input type="text" value={nombreCuenta} onChange={(e) => handleNombreCuenta(e.target.value)} className={inputClass} />
                </Field>
                <Field label="CLABE" error={validateCuentaError}>
                    <input type="text" value={clabe} onChange={(e) => handleClabe(e.target.value)} className={inputClass} />
                </Field>
                <Field label="Banco">
                    <p className="text-sm font-medium text-slate-900">{banco || 'Se detecta al escribir la CLABE'}</p>
                </Field>
            </Modal>
        </Page>
    )
}
